/* eslint-disable sonarjs/no-duplicate-string */
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';

export const BAG_PAGE_LABELS = 'checkout.bagPage';

export const blSflActionSuccess = 'bl_sfl_actionSuccess';
export const lblNeedASAPCartTile = 'lbl_NeedASAP_cartTile';
export const lblPtsCartTile = 'lbl_Pts_cartTile';
export const lblQtyCartTile = 'lbl_Qty_cartTile';
export const lblAddItemsToBag = 'lbl_add_items_to_bag';
export const lblAddToBag = 'lbl_add_to_bag';
export const lblAddingTheItems = 'lbl_adding_the_items';
export const lblApplepayDiscounts = 'lbl_applepay_discounts';
export const lblApplepayEstimatedTax = 'lbl_applepay_estimatedTax';
export const lblApplepayGiftServices = 'lbl_applepay_giftServices';
export const lblApplepayInvalidCityOrState = 'lbl_applepay_invalid_City_or_State';
export const lblApplepayInvalidAddress = 'lbl_applepay_invalid_address';
export const lblApplepayInvalidHouseNumber = 'lbl_applepay_invalid_house_number';
export const lblApplepayInvalidMailboxNumber = 'lbl_applepay_invalid_mailbox_number';
export const lblApplepayInvalidPoBoxNumber = 'lbl_applepay_invalid_po_box_number';
export const lblApplepayInvalidPostalCode = 'lbl_applepay_invalid_postal_code';
export const lblApplepayInvalidStreetName = 'lbl_applepay_invalid_street_name';
export const lblApplepayMultipleLocations = 'lbl_applepay_multipleLocations';
export const lblApplepayNoEmailAddressErrorMessage = 'lbl_applepay_noEmailAddressErrorMessage';
export const lblApplepayNoLastNameErrorMessage = 'lbl_applepay_noLastNameErrorMessage';
export const lblApplepayNoPhoneNumberErrorMessage = 'lbl_applepay_noPhoneNumberErrorMessage';
export const lblApplepayNonEligibleCountryErrorMessage =
  'lbl_applepay_nonEligibleCountryErrorMessage';
export const lblApplepayNonEligibleStateErrorMessage = 'lbl_applepay_nonEligibleStateErrorMessage';
export const lblApplepayPickUpAt = 'lbl_applepay_pickUpAt';
export const lblApplepayRequiredCity = 'lbl_applepay_required_city';
export const lblApplepayRequiredPostalCode = 'lbl_applepay_required_postal_code';
export const lblApplepayRequiredState = 'lbl_applepay_required_state';
export const lblApplepaySubTotal = 'lbl_applepay_subTotal';
export const lblBagItemDeleteSuccess = 'lbl_bag_itemDeleteSuccess';
export const lblBagpageShareCart = 'lbl_bagpage_share_cart';

export const lblBossUnavailableConfirmationHeading = 'lbl_boss_unavailable_confirmation_heading';
export const lblBossUnavailableConfirmationHeadingOnlyOssItems =
  'lbl_boss_unavailable_confirmation_heading_only_oss_items';
export const lblBossUnavailableConfirmationSubText = 'lbl_boss_unavailable_confirmation_sub_text';
export const lblBossUnavailableGlobalErrorSubtext = 'lbl_boss_unavailable_global_error_subtext';
export const lblBossUnavailableItemLevelError = 'lbl_boss_unavailable_item_level_error';
export const lblBossUnavailableItemLevelError2 = 'lbl_boss_unavailable_item_level_error2';
export const lblCartTileBopis = 'lbl_cartTile_bopis';
export const lblCheckCoupons = 'lbl_check_coupons';
export const lblConfirmationPage = 'lbl_confirmation_page';
export const lblConfirmationPageOrderNotification = 'lbl_confirmation_page_order_notification';
export const lblConfirmationPaidWithVenmo = 'lbl_confirmation_paid_with_venmo';
export const lblCouponAfterpayMsg = 'lbl_coupon_afterpay_msg';
export const lblCouponAfterpayPickupFrom = 'lbl_coupon_afterpay_pickup_from';
export const lblCouponAppleOnholdError = 'lbl_coupon_apple_onhold_error';
export const lblCouponCollapsibleHeader = 'lbl_coupon_collapsible_header';
export const lblCouponExpiredError = 'lbl_coupon_expired_error';
export const lblCouponGenericOnholdMsg = 'lbl_coupon_generic_onhold_msg';
export const lblCouponInvalidFormatError = 'lbl_coupon_invalid_format_error';
export const lblCouponMaxQuantityError = 'lbl_coupon_max_quantity_error';
export const lblCouponMergecartError = 'lbl_coupon_mergecart_error';
export const lblCouponOfferText = 'lbl_coupon_offerText';
export const lblCouponOnholdError = 'lbl_coupon_onhold_error';
export const lblCouponPlaceCashRedemption = 'lbl_coupon_placeCash_Redemption';
export const lblCouponPlaceCashError = 'lbl_coupon_placeCash_error';
export const lblCouponRemovedError = 'lbl_coupon_removed_error';
export const lblCouponRewardText = 'lbl_coupon_rewardText';
export const lblCouponSeeRedeemDates = 'lbl_coupon_seeRedeemDates';
export const lblCouponThresholdOnholdMsg = 'lbl_coupon_threshold_onhold_msg';
export const lblCouponUnapplied = 'lbl_coupon_unapplied';
export const lblCouponValidThru = 'lbl_coupon_validThru';
export const lblCouponformHeader = 'lbl_couponform_header';
export const lblCouponformHelp = 'lbl_couponform_help';
export const lblCouponformNewHeaderText = 'lbl_couponform_new_header_text';
export const lblCouponformPlaceholder = 'lbl_couponform_placeholder';
export const lblCouponformSubmit = 'lbl_couponform_submit';
export const lblCouponlistApplied = 'lbl_couponlist_applied';
export const lblCouponlistApplyBtn = 'lbl_couponlist_applyBtn';
export const lblCouponlistApplyTobag = 'lbl_couponlist_applyTobag';
export const lblCouponlistAvailable = 'lbl_couponlist_available';
export const lblCouponlistExpiring = 'lbl_couponlist_expiring';
export const lblCouponlistHelpAppling = 'lbl_couponlist_helpAppling';
export const lblCouponlistLessMoreTxt = 'lbl_couponlist_lessMoreTxt';
export const lblCouponlistModalLongDesc = 'lbl_couponlist_modalLongDesc';
export const lblCouponlistModalShortDesc = 'lbl_couponlist_modalShortDesc';
export const lblCouponlistOnhold = 'lbl_couponlist_onhold';
export const lblCouponlistPPolicy = 'lbl_couponlist_pPolicy';
export const lblCouponlistPlaceCash = 'lbl_couponlist_placeCash';
export const lblCouponlistPrintTxt = 'lbl_couponlist_printTxt';
export const lblCouponlistRewards = 'lbl_couponlist_rewards';
export const lblCouponlistSavings = 'lbl_couponlist_savings';
export const lblCouponlistShowMoreTxt = 'lbl_couponlist_showMoreTxt';
export const lblCouponlistUseBy = 'lbl_couponlist_useBy';
export const lblEddArrivesby = 'lbl_edd_arrivesby';
export const lblEmptyBagHelperMsg = 'lbl_emptyBag_helperMsg';
export const lblEmptyBagInspirationTagLine = 'lbl_emptyBag_inspirationTagLine';
export const lblEmptyBagLoggedInMsg = 'lbl_emptyBag_loggedInMsg';
export const lblEmptyBagLoginIn = 'lbl_emptyBag_loginIn';
export const lblEmptyBagNotLoggedInMsg = 'lbl_emptyBag_notLoggedInMsg';
export const lblEstimateToArrive = 'lbl_estimate_to_arrive';
export const lblEstimatedOrderTotal = 'lbl_estimated_order_total';
export const lblEstimatedTaxAdd = 'lbl_estimated_tax_add';
export const lblEstimatedTaxAddCa = 'lbl_estimated_tax_add_ca';
export const lblEstimatedToShip = 'lbl_estimated_to_ship';
export const lblEstimatedZipPlaceholderCa = 'lbl_estimated_zip_placeholder_ca';
export const lblExtendedPreOrderFooterMsg = 'lbl_extended_preOrder_footer_msg';
export const lblExtendedPreOrderMsg = 'lbl_extended_preOrder_msg';
export const lblExtendedPreOrderToolTipMsg = 'lbl_extended_preOrder_toolTip_msg';
export const lblFreeShippingBannerLabel = 'lbl_freeShippingBanner_label';
export const lblFreeShippingBannerUrlApp = 'lbl_freeShippingBanner_url_app';
export const lblFreeShippingCartTile = 'lbl_freeShipping_cartTile';
export const lblFreeShipping = 'lbl_free_shipping';
export const lblHangOn = 'lbl_hang_on';
export const lblHeaderBag = 'lbl_header_bag';
export const lblHolidayDate = 'lbl_holiday_date';
export const lblHolidayMessage = 'lbl_holiday_message';
export const lblHolidayMessageConfirmation = 'lbl_holiday_message_confirmation';
export const lblItemDeleteModalButtonConfirmDelete = 'lbl_itemDelete_modalButtonConfirmDelete';
export const lblItemDeleteModalButtonSFL = 'lbl_itemDelete_modalButtonSFL';
export const lblItemDeleteModalHeading = 'lbl_itemDelete_modalHeading';
export const lblItemDeleteModalTitle = 'lbl_itemDelete_modalTitle';
export const lblLoginSuggestionForSfl = 'lbl_login_suggestion_for_sfl';
export const lblLowInvetoryCartTile = 'lbl_low_invetory_cart_tile';
export const lblLowInvetoryThresholdBOPIS = 'lbl_low_invetory_threshold_BOPIS';
export const lblLowInvetoryThresholdBOSS = 'lbl_low_invetory_threshold_BOSS';
export const lblLowInvetoryThresholdSFL = 'lbl_low_invetory_threshold_SFL';
export const lblLowInvetoryThresholdShipToHome = 'lbl_low_invetory_threshold_ship_to_home';
export const lblMsgItemDeleteSuccess = 'lbl_msg_itemDeleteSuccess';
export const lblOrderledgerBalance = 'lbl_orderledger_balance';
export const lblOrderledgerBuyWith = 'lbl_orderledger_buyWith';
export const lblOrderledgerCoupons = 'lbl_orderledger_coupons';
export const lblOrderledgerFree = 'lbl_orderledger_free';
export const lblOrderledgerGiftServices = 'lbl_orderledger_giftServices';
export const lblOrderledgerGiftcards = 'lbl_orderledger_giftcards';
export const lblOrderledgerPromotions = 'lbl_orderledger_promotions';
export const lblOrderledgerTax = 'lbl_orderledger_tax';
export const lblOrderledgerTitle = 'lbl_orderledger_title';
export const lblOrderledgerTooltiptext = 'lbl_orderledger_tooltiptext';
export const lblOrderledgerTotal = 'lbl_orderledger_total';
export const lblOrderledgerTotalConfirmation = 'lbl_orderledger_totalConfirmation';
export const lblPlccIcBuyNow = 'lbl_plcc_ic_buy_now';
export const lblPlccIcCreditCard = 'lbl_plcc_ic_credit_card';
export const lblPlccIcInstantCheckout = 'lbl_plcc_ic_instant_checkout';
export const lblPlccIcMyPlaceRewards$ = 'lbl_plcc_ic_my_place_rewards$';
export const lblPlccIcShippingAdress = 'lbl_plcc_ic_shipping_adress';
export const lblPlccIcTermsCondition = 'lbl_plcc_ic_termsCondition';
export const lblPlccIcTermsConditionPreTextApp = 'lbl_plcc_ic_termsCondition_preText_app';
export const lblPlccIcToolTipMessage1 = 'lbl_plcc_ic_toolTip_message_1';
export const lblPlccIcToolTipMessage2 = 'lbl_plcc_ic_toolTip_message_2';
export const lblPreOrderTag = 'lbl_pre_order_tag';
export const lblPreorderDate = 'lbl_preorder_date';
export const lblPreorderItemsEdd = 'lbl_preorder_items_edd';
export const lblQtyText = 'lbl_qty_text';
export const lblRecentlyViewedEmptyBagPage = 'lbl_recently_viewed_empty_bag_page';
export const lblRecentlyViewedFullBagPage = 'lbl_recently_viewed_full_bag_page';
export const lblRewardAndCouponTitle = 'lbl_reward_and_coupon_title';
export const lblSavingForLaterSuggestion = 'lbl_saving_for_later_suggestion';
export const lblSflActionError = 'lbl_sfl_actionError';
export const lblSflCartSflMergedSuccessMsg = 'lbl_sfl_cartSflMergedSuccessMsg';
export const lblSflEmptySflMsg1 = 'lbl_sfl_emptySflMsg_1';
export const lblSflEmptySflMsg2 = 'lbl_sfl_emptySflMsg_2';
export const lblSflItemDeleteSuccess = 'lbl_sfl_itemDeleteSuccess';
export const lblSflItemMoveToBagSuccess = 'lbl_sfl_itemMoveToBagSuccess';
export const lblSflMaxLimitError = 'lbl_sfl_maxLimitError';
export const lblSflMoveToBag = 'lbl_sfl_moveToBag';
export const lblSflSavedForLater = 'lbl_sfl_savedForLater';
export const lblSflSavedLaterButton = 'lbl_sfl_savedLaterButton';
export const lblSflViewsfl = 'lbl_sfl_viewsfl';
export const lblShareCartCancel = 'lbl_share_cart_cancel';
export const lblShareCartSmsCopy = 'lbl_share_cart_sms_copy';
export const lblSigninCtaBannerSignin = 'lbl_signin_cta_banner_signin';
export const lblSocialProofingMsg = 'lbl_social_proofing_msg';
export const lblUpdateItems = 'lbl_update_items';
export const lblUseByDate = 'lbl_use_by_date';
export const lblVenmoProceedCheckout = 'lbl_venmo_proceed_checkout';
export const lblVmpError = 'lbl_vmp_error';
export const lblYouMayAlsoLike = 'lbl_you_may_also_like';
export const lblYouMayAlsoLikeEmptyBagPage = 'lbl_you_may_also_like_empty_bag_page';
export const lblYouMayAlsoLikeFullBagPage = 'lbl_you_may_also_like_full_bag_page';
export const lblYouRecentlyViewed = 'lbl_you_recently_viewed';

export const bagPageLabels = {
  checkout: {
    bagPage: {
      [blSflActionSuccess]: 'Item saved for later successfully.',
      [lblNeedASAPCartTile]: 'Need it ASAP? Get it today!',
      [lblPtsCartTile]: 'Pts',
      [lblQtyCartTile]: 'qty',
      [lblAddItemsToBag]: 'Someone shared their bag with you!',
      [lblAddToBag]: 'YES, VIEW ITEMS',
      [lblAddingTheItems]: 'We’re adding the item(s) to your bag now!',
      [lblApplepayDiscounts]: 'Discounts',
      [lblApplepayEstimatedTax]: 'Est. Tax (final tax at checkout)',
      [lblApplepayGiftServices]: 'Gift Services',
      [lblApplepayInvalidCityOrState]:
        'The city and/or state entered is invalid, please correct the address',
      [lblApplepayInvalidAddress]: 'The address entered is invalid, please correct the address',
      [lblApplepayInvalidHouseNumber]: 'The address entered is invalid, please correct the address',
      [lblApplepayInvalidMailboxNumber]:
        'The address entered is invalid, please correct the address',
      [lblApplepayInvalidPoBoxNumber]: 'The address entered is invalid, please correct the address',
      [lblApplepayInvalidPostalCode]: 'The address entered is invalid, please correct the address',
      [lblApplepayInvalidStreetName]: 'The address entered is invalid, please correct the address',
      [lblApplepayMultipleLocations]: 'PICKUP AT MULTIPLE LOCATIONS',
      [lblApplepayNoEmailAddressErrorMessage]: 'A valid email address is required.',
      [lblApplepayNoLastNameErrorMessage]: 'First and Last name fields are required',
      [lblApplepayNoPhoneNumberErrorMessage]: 'A valid phone number is required.',
      [lblApplepayNonEligibleCountryErrorMessage]: 'Shipping available in US only',
      [lblApplepayNonEligibleStateErrorMessage]: 'Please enter valid 2 character state code',
      [lblApplepayPickUpAt]: 'PICKUP AT',
      [lblApplepayRequiredCity]: 'City is required field',
      [lblApplepayRequiredPostalCode]: 'Postal code is required field',
      [lblApplepayRequiredState]: 'State is required field',
      [lblApplepaySubTotal]: 'Subtotal',
      [lblBagItemDeleteSuccess]: 'An item has been deleted from your bag.',
      [lblBagpageShareCart]: 'Share Bag',
      [lblBossUnavailableConfirmationHeading]: 'We’ve saved the rest of the items in your bag...',
      [lblBossUnavailableConfirmationHeadingOnlyOssItems]: 'Update on cart remaining items!',
      [lblBossUnavailableConfirmationSubText]: 'Ship them to your home for FREE!',
      [lblBossUnavailableGlobalErrorSubtext]: 'ship them home',
      [lblBossUnavailableItemLevelError]: 'Unavailable for No-Rush Pickup.',
      [lblBossUnavailableItemLevelError2]: 'Select Ship to Home and get it delivered to your door!',
      [lblCartTileBopis]: 'I’ll pick up in store at #store# Today',
      [lblCheckCoupons]: 'Check Coupons',
      [lblConfirmationPage]: 'YOU MAY ALSO LIKE',
      [lblConfirmationPageOrderNotification]: 'YOU MAY ALSO LIKE',
      [lblConfirmationPaidWithVenmo]: 'Paid with',
      [lblCouponAfterpayMsg]:
        'You have unapplied coupons! To use them on this order, apply them now before continuing to Afterpay.',
      [lblCouponAfterpayPickupFrom]: 'Pickup Items from',
      [lblCouponAppleOnholdError]: 'Please pay with Apple Pay to apply this coupon.',
      [lblCouponCollapsibleHeader]: 'Rewards & Offers',
      [lblCouponExpiredError]:
        'The coupon applied  to your order coupon_placeholder is no longer valid. Please remove the coupon to continue',
      [lblCouponGenericOnholdMsg]: 'Discount will be applied after Terms and Conditions are met.',
      [lblCouponInvalidFormatError]: 'Please enter a valid promo code',
      [lblCouponMaxQuantityError]:
        'You have reached the limit for the number of items in your bag. Please review your cart as some of your items may not have merged.',
      [lblCouponMergecartError]:
        'A coupon previously applied to your cart is no longer applicable. Please review your cart for any changes',
      [lblCouponOfferText]: 'OFFER',
      [lblCouponOnholdError]:
        'This coupon will apply to your purchase when you use your My Place Rewards Credit Card.',
      [lblCouponPlaceCashRedemption]: 'Redemption date is yet to begin',
      [lblCouponPlaceCashError]: 'Sorry, we are unable to apply your PLACE BUCKS.',
      [lblCouponRemovedError]:
        'One or more of your coupons cannot be applied to your order; see coupon details. Please review and resubmit your order.',
      [lblCouponRewardText]: 'REWARD',
      [lblCouponSeeRedeemDates]: 'See Redeem Dates',
      [lblCouponThresholdOnholdMsg]:
        'Your item total is $XX away from being able to redeem this reward',
      [lblCouponUnapplied]: 'Unapplied Coupons',
      [lblCouponValidThru]: 'Valid thru',
      [lblCouponformHeader]: 'COUPON CODE',
      [lblCouponformHelp]: 'Need help?',
      [lblCouponformNewHeaderText]: 'Benefits, Rewards & Offers',
      [lblCouponformPlaceholder]: 'Enter Code',
      [lblCouponformSubmit]: 'Apply',
      [lblCouponlistApplied]: 'Applied',
      [lblCouponlistApplyBtn]: 'APPLY',
      [lblCouponlistApplyTobag]: 'Apply to bag',
      [lblCouponlistAvailable]: 'Available',
      [lblCouponlistExpiring]: 'EXPIRING SOON!',
      [lblCouponlistHelpAppling]: 'Help applying Place Bucks',
      [lblCouponlistLessMoreTxt]: 'Show less',
      [lblCouponlistModalLongDesc]:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla urna nunc, interdum ac neque non, blandit accumsan justo. Phasellus aliquam urna ut nisl faucibus, quis pellentesque nulla vulputate. Phasellus bibendum lobortis orci, condimentum convallis sa',
      [lblCouponlistModalShortDesc]: 'By participating in the activity, you agree to ',
      [lblCouponlistOnhold]: 'On Hold',
      [lblCouponlistPPolicy]: 'Privacy Policy',
      [lblCouponlistPlaceCash]: 'PLACE BUCKS',
      [lblCouponlistPrintTxt]: 'Print',
      [lblCouponlistRewards]: 'REWARDS',
      [lblCouponlistSavings]: 'SAVINGS',
      [lblCouponlistShowMoreTxt]: 'Show more',
      [lblCouponlistUseBy]: 'Use by',
      [lblEddArrivesby]: 'Arrives by',
      [lblEmptyBagHelperMsg]: '',
      [lblEmptyBagInspirationTagLine]: '',
      [lblEmptyBagLoggedInMsg]: 'Uh oh! Looks like you don’t have anything in your bag yet!',
      [lblEmptyBagLoginIn]: 'LOG IN',
      [lblEmptyBagNotLoggedInMsg]: 'Do you have items in your Bag?',
      [lblEstimateToArrive]: 'Estimated to arrive by',
      [lblEstimatedOrderTotal]: 'Estimated Order Total',
      [lblEstimatedTaxAdd]: 'Add Zip Code',
      [lblEstimatedTaxAddCa]: 'Add Postal Code',
      [lblEstimatedToShip]: 'Estimated to ship by',
      [lblEstimatedZipPlaceholderCa]: 'Postal Code',
      [lblExtendedPreOrderFooterMsg]:
        'Limited payment methods available in checkout due to select pre-order items.',
      [lblExtendedPreOrderMsg]: 'Limited payment methods',
      [lblExtendedPreOrderToolTipMsg]:
        'Due to the extended timeframe of this pre-order item, we are unable to accept PayPal, Afterpay, Apple Pay and Venmo payments.',
      [lblFreeShippingBannerLabel]: '#tagOpen# NEW! #tagClose# FREE Shipping Every Day!',
      [lblFreeShippingBannerUrlApp]: '/content/free-shipping',
      [lblFreeShippingCartTile]: 'Free Shipping',
      [lblFreeShipping]: 'Free Standard Shipping',
      [lblHangOn]: 'Hang on...',
      [lblHeaderBag]: 'MY BAG',
      [lblHolidayDate]: 'Oct 30 2023',
      [lblHolidayMessage]: 'Choose #shippingMethod to get in time for Christmas!',
      [lblHolidayMessageConfirmation]: 'You will get this item before Christmas!',
      [lblItemDeleteModalButtonConfirmDelete]: 'NO THANKS',
      [lblItemDeleteModalButtonSFL]: 'YES, SAVE FOR LATER',
      [lblItemDeleteModalHeading]:
        'It’ll be in the Saved For Later section when you’re ready to shop.',
      [lblItemDeleteModalTitle]: 'Want to save it instead?',
      [lblLoginSuggestionForSfl]: "Log in to see the items you've saved for later!",
      [lblLowInvetoryCartTile]: 'Only [val] left in stock - order soon.',
      [lblLowInvetoryThresholdBOPIS]: '10',
      [lblLowInvetoryThresholdBOSS]: '12',
      [lblLowInvetoryThresholdSFL]: '11',
      [lblLowInvetoryThresholdShipToHome]: '13',
      [lblMsgItemDeleteSuccess]: 'Your item has been deleted.',
      [lblOrderledgerBalance]: 'Balance',
      [lblOrderledgerBuyWith]: 'Buy With',
      [lblOrderledgerCoupons]: 'Coupons',
      [lblOrderledgerFree]: 'FREE',
      [lblOrderledgerGiftServices]: 'Gift Service',
      [lblOrderledgerGiftcards]: 'Gift Card(s)',
      [lblOrderledgerPromotions]: 'Promotions',
      [lblOrderledgerTax]: 'Estimated Tax',
      [lblOrderledgerTitle]: 'Order Summary',
      [lblOrderledgerTooltiptext]:
        'Total includes any applied promotions or coupons in addition to on sale savings',
      [lblOrderledgerTotal]: 'Estimated Total',
      [lblOrderledgerTotalConfirmation]: 'Total',
      [lblPlccIcBuyNow]: 'BUY NOW',
      [lblPlccIcCreditCard]: 'CREDIT CARD',
      [lblPlccIcInstantCheckout]: 'INSTANT CHECKOUT',
      [lblPlccIcMyPlaceRewards$]: 'My Place Rewards$',
      [lblPlccIcShippingAdress]: 'Shipping to #adress',
      [lblPlccIcTermsConditionPreTextApp]: 'By selecting “Buy Now”, I agree to the ',
      [lblPlccIcToolTipMessage1]:
        'NEW! Buy Now is the fastest way to check out every time you shop with your online account. ',
      [lblPlccIcToolTipMessage2]:
        'When you select Buy Now, we’ll charge the My Place Rewards Credit Card saved in your account and deliver to your default shipping address. Your order will be placed with a single click, and you’ll be directed to the Order Confirmation page.  ',
      [lblPreOrderTag]: 'Pre Order',
      [lblPreorderDate]: 'PREORDER - SHIPS BY',
      [lblPreorderItemsEdd]: '*Pre-order items expected to ship by',
      [lblQtyText]: 'Qty',
      [lblRecentlyViewedEmptyBagPage]: 'Recently Viewed',
      [lblRecentlyViewedFullBagPage]: 'Recently Viewed',
      [lblRewardAndCouponTitle]: 'Rewards & Coupons',
      [lblSavingForLaterSuggestion]:
        "Select 'Save for Later' and we'll hold onto your items until you're ready to make a purchase.",
      [lblSflActionError]: 'Sorry we were unable to save your item for later at this time.',
      [lblSflCartSflMergedSuccessMsg]:
        'Item(s) from your last visit moved to Saved For Later section',
      [lblSflEmptySflMsg1]: 'Not ready to buy anything yet?',
      [lblSflEmptySflMsg2]: 'You can save it for later and it will appear in this area.',
      [lblSflItemDeleteSuccess]: 'Your item has been removed.',
      [lblSflItemMoveToBagSuccess]: 'Your item has been added to bag.',
      [lblSflMaxLimitError]:
        'Sorry you have reached the max number of items that can be saved for later.',
      [lblSflMoveToBag]: 'Move To Bag',
      [lblSflSavedForLater]: 'SAVED FOR LATER',
      [lblSflSavedLaterButton]: 'Saved for Later',
      [lblSflViewsfl]: 'View Saved for Later',
      [lblShareCartCancel]: 'Cancel',
      [lblShareCartSmsCopy]: 'Check out the styles I found at #brandId today: ',
      [lblSigninCtaBannerSignin]: 'Sign in',
      [lblSocialProofingMsg]:
        'PLACE Bucks ends TODAY - <span class=social-proof-checkout-msg>spend them now!</span>',
      [lblUpdateItems]:
        'Select Yes to view items. You can also update the size, color, quantity and more.',
      [lblUseByDate]: 'Use By',
      [lblVenmoProceedCheckout]: 'Proceed to checkout with ',
      [lblVmpError]:
        "Sorry one or more items in your cart are exclusive to Children's Place or Gymboree. If you still need those items please ## to checkout from that site.",
      [lblYouMayAlsoLike]: 'BASED ON ITEMS IN YOUR BAG',
      [lblYouMayAlsoLikeEmptyBagPage]: 'You May Also Like',
      [lblYouMayAlsoLikeFullBagPage]: 'You May Also Like',
      [lblYouRecentlyViewed]: 'RECENTLY VIEWED',
      [lblPlccIcTermsCondition]:
        '<style>     .linking-create {         color:000;         text-decoration:one;         text-decoration:nderline;     } </style> By selecting “Buy Now”, I agree to the  <a class="linking-create"     href="/help-center/terms-conditions#termsandconditions" target="_blank">Terms & Conditions</a> and <a     class="linking-create" href="/help-center/policies#privacypolicy" target="_blank">Privacy Policy</a> ',
    },
  },
};

export function getBagPageLabels() {
  return getLabelFromCopyOrFromTranslation(BAG_PAGE_LABELS, bagPageLabels);
}
